import React, { Component } from 'react';
import './App.css';
import './theme/portal-chrome.css';
import './theme/alert.css';

import Landing from "./Landing";
import Home from "./Home";
import JInform from './jinform/JInform';
import Misanthropy from './misanthropy/Misanthropy';

import { handleCartClose, handleCartOpen } from './redux/actions/cartActions';
import { handleAlertClose } from './redux/actions/alertActions';

import { Helmet } from "react-helmet";
import IconButton from '@mui/material/IconButton';

import CloseIcon from '@mui/icons-material/Close';
import AccountBoxIcon from '@mui/icons-material/AccountBox';

import { Route, NavLink } from "react-router-dom";
import { signOut } from './auth/AuthService';
import { clearSessionData } from './redux/actions';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { SessionStatus } from './redux/actions'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookSquare, faTwitterSquare } from "@fortawesome/free-brands-svg-icons";

import { Alert, AlertTitle } from '@mui/material';
import Collapse from '@mui/material/Collapse';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { connect } from 'react-redux';

// Routes that use a full-viewport layout — footer is hidden on these
const FULL_SCREEN_PATHS = [
	'/misanthropy',
	'/bookshelf/default',
	'/bookshelf/story1',
	'/bookshelf/story2'
];

class App extends Component {
	constructor(props) {
		super(props);
		this.getBreadcrumbName = this.getBreadcrumbName.bind(this);

		this.handleCartClose = this.props.handleCartClose.bind(this);
        this.handleCartOpen = this.props.handleCartOpen.bind(this);
		this.handleAlertClose = this.props.handleAlertClose.bind(this);

		this.clearSessionData = this.props.clearSessionData.bind(this);
		this.state = {
		};
	}

	handleSignOut() {
		signOut().then(signOutAttempt => this.clearSessionData(signOutAttempt));
	};

	handleMenuOpen = event => {
    	this.setState({ anchorEl: event.currentTarget });
	};

    handleMenuClose() {
    	this.setState(state => ({
			anchorEl: null
		}));
    };

	handleMenuLogout() {
		this.handleMenuClose();
		this.handleSignOut();
    };

	toggleDrawer(anchor, open) {
		this.setState(state => ({
			[anchor]: open
		}));
    };

	// The background-color contained here sets the background for the entire app!
	render() {
		return (
			<div className="App">

				<Helmet>
					<style>{'body { background-color: #fafafa; }'}</style>
					<title>Newfangle Press</title>
					<meta name="google-site-verification" content="NGCtSxuSzrQED1Pm4oA36ZQnW5Q4U_5Cqidht9CYiB4"/>

					<link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png"/>
					<link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png"/>
					<link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png"/>
					<link rel="manifest" href="/site.webmanifest"/>
					<link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5"/>
					<meta name="msapplication-TileColor" content="#da532c"/>
					<meta name="theme-color" content="#ffffff"/>
				</Helmet>

				<Backdrop style={{ "color": "#a22f7d", "zIndex": "1200" }} open={this.props.isProgressOpen}>
                    <CircularProgress color="inherit" />
                </Backdrop>

				<header className="nf-masthead">
					<div className="nf-masthead-in">
						<NavLink className="nf-brand" to="/">
							<span className="nf-brand-name">Newfangle Press</span>
							<span className="nf-brand-tag">Independent &middot; Cincinnati &middot; Est. 2020</span>
						</NavLink>

						{
							(SessionStatus.LOGGED_IN === this.props.sessionStatus) &&
							<div className="nf-actions">
								<button type="button" className="nf-icon-btn" aria-label="Account" onClick={this.handleMenuOpen.bind(this)}>
									<AccountBoxIcon fontSize="small"/>
								</button>
								<Menu id="account-menu" anchorEl={this.state.anchorEl}
										open={Boolean(this.state.anchorEl)} onClose={this.handleMenuClose.bind(this)}
									anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
									transformOrigin={{ vertical: 'top', horizontal: 'right' }}
									slotProps={{ paper: { sx: {
										mt: 1, minWidth: 200,
										background: 'var(--nf-surface)',
										color: 'var(--nf-ink)',
										border: '1px solid var(--nf-hairline)',
										borderRadius: '8px',
										boxShadow: '0 20px 50px -20px rgba(0,0,0,.8)'
									} } }}
								>
									{
										this.props.username &&
										<div style={{ padding: '10px 16px 10px', borderBottom: '1px solid var(--nf-hairline)' }}>
											<div style={{ fontFamily: 'var(--nf-font-mono)', fontSize: 9.5, letterSpacing: '.18em', textTransform: 'uppercase', color: 'var(--nf-muted)' }}>Signed in as</div>
											<div style={{ fontFamily: 'var(--nf-font-body)', fontSize: 14, color: 'var(--nf-ink)', marginTop: 3 }}>{this.props.username}</div>
										</div>
									}
									<MenuItem onClick={this.handleMenuLogout.bind(this)}
										sx={{ fontFamily: 'var(--nf-font-body)', fontSize: 14, color: 'var(--nf-ink)', py: 1.2, '&:hover': { background: 'rgba(255,255,255,0.05)', color: 'var(--nf-accent-hover)' } }}
									>
										Log out
									</MenuItem>
								</Menu>
							</div>
						}
					</div>
				</header>

				<div style={{ flex: 1, overflow: 'auto', position: 'relative', minHeight: 0, backgroundColor: '#141110' }}>

				<Collapse in={this.props.isAlertOpen} className="nf-alert-anchor" style={{ position: "fixed", zIndex: "1742" }}>
					<Alert className="nf-alert" severity={this.props.alertSeverity}
						action={
							<IconButton
								aria-label="close"
								color="inherit"
								size="small"
								onClick={this.handleAlertClose}
							>
								<CloseIcon fontSize="inherit" />
							</IconButton>
						}
					>
						<AlertTitle>{this.props.alertTitle}</AlertTitle>
						{this.props.alertMessage}
					</Alert>
				</Collapse>

				{
					(SessionStatus.LOGGED_IN !== this.props.sessionStatus) &&
					<Route path="/">
						<Landing/>
					</Route>
				}

				{
					(SessionStatus.LOGGED_IN === this.props.sessionStatus) &&
					<Route exact path="/">
						<Home/>
					</Route>
				}
				{
					(SessionStatus.LOGGED_IN === this.props.sessionStatus) &&
					<Route exact path="/bookshelf/:titleId" component={JInform}/>
				}
				{
					(SessionStatus.LOGGED_IN === this.props.sessionStatus) &&
					<Route path="/misanthropy" component={Misanthropy}/>
				}

				{!FULL_SCREEN_PATHS.some(p => window.location.pathname.startsWith(p)) && (
					<footer className="nf-footer">
						<div className="nf-footer-social">
							<a href="https://facebook.com/newfanglepress" aria-label="Facebook">
								<FontAwesomeIcon icon={faFacebookSquare} size="2x"/>
							</a>
							<a href="https://twitter.com/NewfanglePress" aria-label="Twitter">
								<FontAwesomeIcon icon={faTwitterSquare} size="2x"/>
							</a>
						</div>
						<div className="nf-footer-copy">Copyright &#169; 2020, 2024 Newfangle Media LLC &#9670; Cincinnati, Ohio &#9670; USA</div>
					</footer>
				)}

				</div>{/* end content wrapper */}
			</div>
		);
	};

	getBreadcrumbName(to) {
		var retVal = '\u2026';

		if (this.props.breadcrumbs[to]) {
			retVal = this.props.breadcrumbs[to];
		}

		return retVal;
	};

}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
		clearSessionData: (signOutAttempt) => {
			dispatch(clearSessionData());
		},
		handleCartClose: () => {
            dispatch(handleCartClose());
		},
        handleCartOpen: () => {
            dispatch(handleCartOpen());
		},
		handleAlertClose: () => {
			dispatch(handleAlertClose());
		}
    }
}

const mapStateToProps = (state, ownProps) => {
	return {
		alertTitle: state.alert.alertTitle,
        alertSeverity: state.alert.alertSeverity,
        alertMessage: state.alert.alertMessage,
        isAlertOpen: state.alert.isAlertOpen,
		isProgressOpen: state.alert.isProgressOpen,
		sessionStatus: state.session.sessionStatus,
		username: state.session.username,
		checkout: state.cart.checkout,
        isCartOpen: state.cart.isCartOpen,
		breadcrumbs: state.breadcrumbs
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
